import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoImportarEstoque } from 'pages/compra/configuracao-pedido/types';

export function useQueryImportarEstoque() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    return useQuery<ConfigPedidoImportarEstoque>({
        queryKey: ['config-pedido-importar-estoque', id],
        queryFn: () =>
            requestListagem({
                url: `/gestao/configpedidoprodutoestoque/configpedido/${id}`,
            }).then((res) => ({
                configPedidoImportarEstoque: res.data,
            })),
    });
}
